module.exports = __webpack_public_path__ + "img/ExitusC_terceraParte.87531441.png";